import { render } from "./App.vue?vue&type=template&id=1bb1e2d3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1bb1e2d3&lang=less"
script.render = render

export default script